import './Toggle.scss';

interface ToggleProps {
  name: string;
  onChange?: (name: string) => void;
  checked: boolean;
  disabled?: boolean;
}

function Toggle({ name, onChange, checked, disabled }: Readonly<ToggleProps>) {
  const handleOnChange = () => {
    onChange?.(name);
  };

  return (
    <label id={name} htmlFor={name} className="stratus--toggle">
      <input
        type="checkbox"
        onChange={disabled ? () => null : handleOnChange}
        checked={checked}
        name={name}
      />
      <span
        onClick={disabled ? () => null : handleOnChange}
        className={`stratus--slider round ${disabled ? 'disabled' : ''}`}
        role="button"
      />
    </label>
  );
}

export default Toggle;
